import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeFromDateCommand extends BaseCommand {
  CommandName = "ChangeFromDate";
  Command: { TmpId: string; Value: string };
  constructor(sessionId: string, operationId: string, tmpId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId, Value: value };
  }
}
